export default __webpack_public_path__ + "static/media/rh-ico.888b075b.svg";